import script from "./MindMapView.vue?vue&type=script&setup=true&lang=js"
export * from "./MindMapView.vue?vue&type=script&setup=true&lang=js"

import "./MindMapView.vue?vue&type=style&index=0&id=216be866&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-216be866"]])

export default __exports__